(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 92332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'spinner';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f110';
var svgPathData = 'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(79503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-brake-repair-header.e9c70732.jpeg","height":650,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQMREgITUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8Amm3NtyyLN3IWeAAFf//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 57581:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-brake-repair-header.e9c70732.jpg","height":650,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQMREgITUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8Amm3NtyyLN3IWeAAFf//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5120:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-logo-no-text.7abecb29.svg","height":47,"width":94});

/***/ }),

/***/ 8617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ AboutPageTitleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_img_nubrakes_brake_repair_header_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12535);
/* harmony import */ var _BgImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63549);




var AboutPageTitleSection = function(param) {
    var title = param.title, description = param.description, bgImageOverride = param.bgImageOverride;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BgImage__WEBPACK_IMPORTED_MODULE_3__/* .BgImage */ .D, {
            src: _public_img_nubrakes_brake_repair_header_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z || bgImageOverride,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "title text-white",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 63549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BgImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_img_nubrakes_brake_repair_header_jpg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57581);



var BgImage = function(param) {
    var src = param.src, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center align-center relative h-[45vh] sm:h-[60vh]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src !== null && src !== void 0 ? src : _public_img_nubrakes_brake_repair_header_jpg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                alt: "NuBrakes Background Image",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "top left"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    zIndex: 1
                },
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 12049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ContactUsForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82175);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74231);
/* harmony import */ var _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12640);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_quote_form_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53829);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68663);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSpinner__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92332);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59397);
/* harmony import */ var _clients_new_backend_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36826);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      mutation contactUs($contactUsInput: ContactUsInput!) {\n        contactUs(contactUsInput: $contactUsInput)\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var formSchema = yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
    firstName: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required("Required"),
    lastName: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required("Required"),
    email: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().email().required("Required"),
    message: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required("Required")
});
function submitToBackend(values) {
    return _submitToBackend.apply(this, arguments);
}
function _submitToBackend() {
    _submitToBackend = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
        var formName, rest;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formName = values["form-name"], rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(values, [
                        "form-name"
                    ]);
                    return [
                        4,
                        _clients_new_backend_client__WEBPACK_IMPORTED_MODULE_9__/* .newBackendClient.mutate */ .t.mutate({
                            variables: {
                                contactUsInput: rest
                            },
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)(_templateObject())
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _submitToBackend.apply(this, arguments);
}
var ContactUsForm = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Formik */ .J9, {
        initialValues: {
            "form-name": "contact",
            email: "",
            lastName: "",
            firstName: "",
            message: ""
        },
        validationSchema: formSchema,
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    submitToBackend(values),
                                    (0,_util_quote_form_utils__WEBPACK_IMPORTED_MODULE_6__/* .catchAll */ .km)(values)
                                ])
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                router.push("/contact-success/").then(function() {
                                    return window.scrollTo(0, 0);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var isSubmitting = param.isSubmitting;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Form */ .l0, {
                name: "contactForm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                        type: "hidden",
                        name: "form-name",
                        value: "contactForm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "grid md:grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                            name: "firstName",
                                            component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                            name: "lastName",
                                            component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                            required: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                    name: "email",
                                    type: "email",
                                    component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_14__/* .Field */ .gN, {
                                    name: "message",
                                    as: "textarea",
                                    component: _Fields_CustomTextField__WEBPACK_IMPORTED_MODULE_4__/* .CustomTextField */ .yM,
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
                        disabled: isSubmitting,
                        type: "submit",
                        children: isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_8__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons_faSpinner__WEBPACK_IMPORTED_MODULE_15__/* .faSpinner */ .LM,
                            spin: true
                        }) : "Submit"
                    })
                ]
            });
        }
    });
};


/***/ }),

/***/ 17743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LandingPageButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);








function LandingPageButton(props) {
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: "/get-quote/",
            query: query
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(props.className),
                style: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 25,
                    paddingRight: 25
                }
            }, props.buttonProps), {
                children: props.buttonText
            }))
        })
    });
}


/***/ }),

/***/ 79503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var GraySection = __webpack_require__(18737);
// EXTERNAL MODULE: ./public/img/nubrakes-logo-no-text.svg
var nubrakes_logo_no_text = __webpack_require__(5120);
;// CONCATENATED MODULE: ./src/components/AboutPage/ScheduleServiceCallToActionSection.tsx







var ScheduleServiceCallToActionSection = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "mx-auto",
                                src: nubrakes_logo_no_text/* default */.Z,
                                alt: "NuBrakes Logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        paddingTop: "5%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                        buttonText: "Get A Free Brake Service Estimate"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
;// CONCATENATED MODULE: ./src/components/Contact/ContactUsSideBar.tsx



var ContactUsSideBar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "contact-sidebar",
        style: {
            color: "#818b92"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "title",
                style: {
                    color: "black",
                    fontSize: 26,
                    fontWeight: 500
                },
                children: "NuBrakes Contact"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "call-us",
                children: "Call Us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Austin",
                phoneNumber: "5126402560"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Dallas-Fort Worth",
                phoneNumber: "4697063497"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Houston",
                phoneNumber: "8327064115"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "San Antonio",
                phoneNumber: "2107946444"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Atlanta",
                phoneNumber: "4704677736"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Nashville",
                phoneNumber: "6292061979"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Tampa",
                phoneNumber: "8139579076"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Jacksonville",
                phoneNumber: "9048674476"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Orlando",
                phoneNumber: "6892164829"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Miami",
                phoneNumber: "7867802495"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityContactUs, {
                cityName: "Chicago",
                phoneNumber: "7732426985"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headquarters, {})
        ]
    });
};
var cityNameStyles = {
    marginBottom: 0,
    color: "#818b92"
};
var Headquarters = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: cityNameStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "Headquarters"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: cityNameStyles,
                children: "2028 E Ben White Blvd #240-9317"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: cityNameStyles,
                children: "Austin, Texas 78741"
            })
        ]
    });
};
var CityContactUs = function(param) {
    var cityName = param.cityName, phoneNumber = param.phoneNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: cityNameStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                    children: [
                        cityName,
                        " Brake Repair"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "tel:".concat(phoneNumber),
                children: (0,string_utils/* formatPhoneNumber */.u)(phoneNumber)
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Forms/ContactUsForm.tsx
var ContactUsForm = __webpack_require__(12049);
;// CONCATENATED MODULE: ./src/components/Contact/ContactUsFormSection.tsx





var ContactUsFormSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-12 gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsSideBar, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsForm/* ContactUsForm */.x, {})
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/AboutPageTitleSection.tsx
var AboutPageTitleSection = __webpack_require__(8617);
;// CONCATENATED MODULE: ./src/pages/contact.tsx







var ContactPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Contact Us - NuBrakes Mobile Brake Repair",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Contact the NuBrakes mobile brake repair team."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutPageTitleSection/* AboutPageTitleSection */.P, {
                title: "Contact Us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsFormSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleServiceCallToActionSection, {
                title: "Schedule your mobile brake repair in minutes."
            })
        ]
    });
};
/* harmony default export */ var contact = (ContactPage);


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2978,4231,7858,2932,6566,9774,2888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);